import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { S1Table, S1ButtonType, S1UIService } from '@app/s1';
import { IPista } from '@app/shared/models/pista';
import { PistaService, IRicercaPistaParams } from '@app/shared/services/pista.service';
import { PistaComponent } from '../pista/pista.component';

@Component({
  selector: 'ser-piste',
  templateUrl: './piste.component.html',
  styleUrl: './piste.component.scss'
})
export class PisteComponent {
  @Input() set idStazione(newValue: string) {
    this._idStazione = newValue;
    if (this._idStazione) {
      this.pistaService.idPath = this._idStazione;
      this.search();
    }
  }

  @ViewChild('pistaModal') pistaModal: PistaComponent;

  @ViewChild('table') table: S1Table<IPista>;

  s1ButtonType = S1ButtonType

  searchForm: UntypedFormGroup;

  _idStazione: string;

  constructor (
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private pistaService: PistaService,
    private ui: S1UIService) {

    this.searchForm = this.formBuilder.group({
      'codice': [null, null],
      'attiva': [null, null],
      'idStazione': [null, null]
    })

  }

  ngAfterViewInit(): void { 
    this.search();
  }

  search() {

    if (!this.table) {
      return;
    }

    let param: IRicercaPistaParams = {
      page: this.table?.config.pagination.page.page,
      pageSize: +this.table?.config.pagination.page.itemsPerPage,
      sortBy: "descrizione",
      codice: this.searchForm.controls.codice.value,
      idStazione: this._idStazione
    }

    this.pistaService.ricerca(param).subscribe(pistePaginate => {
      this.table.updateData(pistePaginate.elements, pistePaginate.paginationInfo)
    })

  }

  goToNew() {
    this.pistaModal.open(this._idStazione);
  }

  goToDetail(pista: IPista = null) {
    this.pistaModal.open(this._idStazione, pista);
  }

  askDelete(pista: IPista) {

    this.ui.showDialogPopup("piste.messages.delete").then(result => {
      if (result.value) {
        this.delete(pista)
      }
    })

  }

  private delete(pistaToDelete: IPista) {

    this.pistaService.elimina(pistaToDelete?.id).subscribe(deleted => {

      if (deleted) {
        this.ui.showSuccessToast("piste.messages.deleted")
        this.table?.refreshAfterDelete()
      }

    })

  }

}
